import { render } from "./ZendeskSellLogoIcon.vue?vue&type=template&id=60723e02"
import script from "./ZendeskSellLogoIcon.vue?vue&type=script&lang=js"
export * from "./ZendeskSellLogoIcon.vue?vue&type=script&lang=js"

import "./ZendeskSellLogoIcon.vue?vue&type=style&index=0&id=60723e02&lang=css"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__